import { Vehicle } from '@agilox/common';

const VEHICLE_SEPARATOR = ', ';

export function buildSubscriptionVehicleList(vehicles: Vehicle[], conjunction: string): string {
	const displayNames = vehicles.map((vehicle: Vehicle) => `${vehicle.name} (${vehicle.serial})`);

	if (displayNames.length < 2) {
		return displayNames.join('');
	}

	const lastDisplayName = displayNames.pop();
	return `${displayNames.join(VEHICLE_SEPARATOR)} ${conjunction} ${lastDisplayName}`;
}
